//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ACTION_RESET_FOCUSED_PRODUCT_TILE } from '@/scripts/store/plp/actions'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: mapActionsPlp } = createNamespacedHelpers('plp')

export default {
  name: 'rb-sort-by',
  props: {
    sortOptions: {
      type: Array,
      default: () => [],
    },
    appliedSortBy: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    selectedSortBy() {
      if (!this.appliedSortBy) {
        return this.sortOptions?.[0]?.label
      }
      return this.sortOptions?.find((sortBy) => sortBy.value === this.appliedSortBy)?.label
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (e.pointerType !== 'mouse') {
        return
      }

      if (!e.target?.offsetParent?.classList.contains('--no-selection')) {
        this.open = false
      }
    })
  },
  methods: {
    ...mapActionsPlp({
      resetFocusedTileId: ACTION_RESET_FOCUSED_PRODUCT_TILE,
    }),
    selectOption(option) {
      this.$emit('changed', option.value)
    },
    toggleSortBy() {
      this.open = !this.open
    },
    checkActiveSelection(option) {
      if (!option.value && !this.appliedSortBy) {
        return true
      }
      return option.value === this.appliedSortBy
    },
  },
}
